import * as types from "./actionTypes";
import * as groupsApi from "../../api/groupsApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";


export function groupLoaded(group) {
    return { type: types.LOAD_GROUP, group }
}

export function userGroupsLoaded(results) {
    return { type: types.LOAD_USER_GROUPS, results }
}

export function groupEdited(group) {
    return { type: types.EDIT_GROUP, group }
}

export function groupCreated(group) {
    return { type: types.CREATE_GROUP, group }
}

export function groupAvatarUpdated(avatar) {
    return { type: types.UPDATE_GROUP_AVATAR, avatar }
}

export function userAddedToGroup(user, groupId) {
    return { type: types.ADD_USER_GROUP, user, groupId }
}

export function userRemovedFromGroup(userId, groupId) {
    return { type: types.REMOVE_USER_GROUP, userId, groupId }
}

export function userMadeGroupAdmin(user, groupId) {
    return { type: types.MAKE_USER_ADMIN_GROUP, user, groupId }
}

export function userRevokedGroupAdmin(user, groupId) {
    return { type: types.REVOKE_USER_ADMIN_GROUP, user, groupId }
}

export function groupMembershipRequested(user, groupId) {
    return { type: types.REQUEST_MEMBERSHIP_GROUP, user, groupId }
}

export function userGroupMembershipConfirmed(user, groupId) {
    return { type: types.CONFIRM_MEMBERSHIP_GROUP, user, groupId }
}

export function userGroupMembershipRejected(user, groupId, reason) {
    return { type: types.REJECT_MEMBERSHIP_GROUP, user, groupId, reason }
}

export function memberRejectionCleared(user, groupId) {
    return { type: types.MEMBERSHIP_REJECTION_CLEARED, user, groupId}
}

export function memberRejectionOverturned(user, groupId) {
    return { type: types.MEMBERSHIP_REJECTION_OVERTURNED, user, groupId}
}

export function groupArchived(groupId) {
    return { type: types.ARCHIVE_GROUP, groupId }
}

export function groupReactivated(groupId) {
    return { type: types.REACTIVATE_GROUP, groupId }
}

export function bannerVersionUpdated(banner) {
    return { type: types.UPDATE_GROUP_BANNER, banner }
}

export function clearGroups() {
    return { type: types.RESET_GROUPS }
}

export function groupInvitationLoaded(invitation) {
    return { type: types.GROUP_INVITATION_LOADED, invitation }
}

export function groupInvitationArchived() {
    return { type: types.GROUP_INVITATION_ARCHIVED }
}

export function loadGroupByFriendlyUrl(url) {
    return dispatch => {
        return groupsApi.getGroupByFriendlyUrl(url)
            .then(group => {
                dispatch(groupLoaded(group));
                return group;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadGroup(id) {
    return dispatch => {
        return groupsApi.getGroup(id)
            .then(group => {
                dispatch(groupLoaded(group));
                return group;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadGroupPublicView(id) {
    return dispatch => {
        return groupsApi.getGroupNameAndAvatar(id)
            .then(group => {
                return group;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadUserGroups() {
    return dispatch => {
        return groupsApi.getUserGroups()
            .then(results => {
                dispatch(userGroupsLoaded(results));
                return results;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadGroupsForUser(userId) {
    return dispatch => {
        return groupsApi.getGroupsForUser(userId)
            .then(results => {
                return results;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function createGroup(group) {
    return dispatch => {
        return groupsApi.saveGroup(group)
            .then(newGroup => {
                group.id = newGroup.id; 
                dispatch(groupCreated(newGroup));
                return newGroup;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function editGroup(group) {
    return dispatch => {
        return groupsApi.saveGroup(group)
            .then(() => {
                dispatch(groupEdited(group));
                return group;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function uploadAvatar(avatar, group) {
    return dispatch => {
        return groupsApi.uploadAvatar(avatar)
            .then(() => {
                dispatch(groupAvatarUpdated(avatar));
                return avatar;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function uploadBanner(banner) {
    return dispatch => {
        return groupsApi.uploadBanner(banner)
            .then(() => {
                dispatch(bannerVersionUpdated(banner));
                return banner;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function addUserToGroup(user, groupId) {
    return dispatch => {
        return groupsApi.addUserToGroup(user.userId, groupId)
            .then(() => {
                dispatch(userAddedToGroup(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function removeUserFromGroup(userId, groupId) {
    return dispatch => {
        return groupsApi.removeUserFromGroup(userId, groupId)
            .then(() => {
                dispatch(userRemovedFromGroup(userId, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function makeUserGroupAdmin(user, groupId) {
    return dispatch => {
        return groupsApi.makeUserGroupAdmin(user.userId, groupId)
            .then(() => {
                dispatch(userMadeGroupAdmin(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function revokeUserGroupAdmin(user, groupId) {
    return dispatch => {
        return groupsApi.revokeUserGroupAdmin(user.userId, groupId)
            .then(() => {
                dispatch(userRevokedGroupAdmin(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function requestGroupMembership(user, groupId) {
    var member = {
        userId: user.id,         firstName: user.firstName,         surname: user.surname,         confirmed: false,         rejected: false,         requested: true,         hasAvatar: user.avatarAvailable,         administrator: false
    }
    return dispatch => {
        return groupsApi.requestGroupMembership(member.userId, groupId)
            .then(() => {
                dispatch(groupMembershipRequested(member, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function confirmUserGroupMembership(user, groupId) {
    user.confirmed = true;
    return dispatch => {
        return groupsApi.confirmUserGroupMembership(user.userId, groupId)
            .then(() => {
                dispatch(userGroupMembershipConfirmed(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function rejectUserGroupMembership(user, groupId, reason) {
    return dispatch => {
        return groupsApi.rejectUserGroupMembership(user.userId, groupId, reason.description)
            .then(() => {
                user.rejectionReason = reason.description; 
                dispatch(userGroupMembershipRejected(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function clearMemberRejection(user, groupId) {
    return dispatch => {
        return groupsApi.removeUserFromGroup(user.userId, groupId)
            .then(() => {
                dispatch(memberRejectionCleared(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function overturnMemberRejection(user, groupId) {
    return dispatch => {
        return groupsApi.confirmUserGroupMembership(user.userId, groupId)
            .then(() => {
                dispatch(memberRejectionOverturned(user, groupId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function searchUsers(searchString, groupId) {
    return dispatch => {
        return groupsApi.searchForUsersAdd(searchString, groupId)
            .then(results => {
                return results;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function archiveGroup(groupId) {
    return dispatch => {
        return groupsApi.archiveGroup(groupId)
            .then(() => {
                dispatch(groupArchived(groupId));
                return;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function reactivateGroup(groupId) {
    return dispatch => {
        return groupsApi.reactivateGroup(groupId)
            .then(() => {
                dispatch(groupReactivated(groupId));
                return;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function searchGroups(searchCriteria) {
    return dispatch => {
        return groupsApi.searchGroups(searchCriteria)
            .then((results) => {
                return results;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function getRecentGroups() {
    return dispatch => {
        return groupsApi.listMostActiveGroups()
            .then((results) => {
                return results;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function resetGroups() {
    return dispatch => {
        dispatch(clearGroups());
    }
}

export function sendGroupInvitations(groupId, emails) {
    return dispatch => {
        return groupsApi.sendGroupInvitations(groupId, emails)
            .then(() => {
                return true;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function getGroupInvitation(code) {
    return dispatch => {
        return groupsApi.getGroupInvitation(code)
            .then((invitation) => {
                dispatch(groupInvitationLoaded(invitation));
                return invitation;
            })
            .catch(error => {
                throw error;
            });
    }
}

export function archiveGroupInvitation(code) {
    return dispatch => {
        return groupsApi.archiveGroupInvitation(code)
            .then(() => {
                dispatch(groupInvitationArchived());
                return;
            })
            .catch(error => {
                throw error;
            });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/groupActions.js